<template>
  <div class="equip-container">
    <div class="t-top-bar">
      <el-input placeholder="请输入内容" v-model="listQuery.keyword" class="input-with-select search-input">
        <el-button  slot="append"  type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
      </el-input>
      <i class="el-icon-circle-plus-outline l-add-buttion" v-if="authedCheck('添加设备')" title="添加设备"
         @click="addHandler"></i>
    </div>
    <el-table :data="tableData" border style="width: 100%" @cell-click="switchClick" v-loading="listLoading">
      <el-table-column prop="equipmentId" label="设备编号"></el-table-column>
      <el-table-column prop="equipmentName" label="设备名称"></el-table-column>
      <el-table-column prop="type" label="终端类型">
        <template slot-scope="scope">
          {{scope.row.type | dicFilter('EQUIP_TYPE')}}
        </template>
      </el-table-column>
      <el-table-column prop="staffTypeCalc" label="员工类型计价" width="180px">
        <template slot-scope="scope">
          <!--{{scope.row.staffTypeCalc | dicFilter('ACTIVE_FLAG')}}-->
          <el-switch v-model="scope.row.staffTypeCalc" @change="staffTypeCalcChange"
                     :active-value="1" :inactive-value="0" active-text="生效" inactive-text="关闭">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column  prop="shiftCalc" label="班次计价" width="180px">
        <template slot-scope="scope">
          <!--{{scope.row.shiftCalc | dicFilter('ACTIVE_FLAG')}}-->
          <el-switch v-model="scope.row.shiftCalc" @change="shiftCalc"
                     :active-value="1" :inactive-value="0" active-text="生效" inactive-text="关闭">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="设备状态">
          <template slot-scope="scope">
              {{scope.row.status | dicFilter('EQUIP_STATUS')}}
          </template>
      </el-table-column>
        <el-table-column prop="name" label="添加时间" width="180px">
            <template slot-scope="scope">
                {{scope.row.createTime | formateTime()}}
            </template>
        </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i class="el-icon-edit el-icon-table btn-primary" v-if="authedCheck('编辑设备')" title="编辑设备"
             @click="editHandler(scope.row)"></i>
<!--          <i class="el-icon-setting el-icon-table btn-warning" @click="detailHandler(scope.row)"></i>-->
          <i class="el-icon-tickets el-icon-table btn-info" @click="switchHis(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog :title="opFlag=='add'?'添加设备':'修改设备'" :visible.sync="addDialogVisiable" @close="addCloseHandler" width="650px">
      <el-form :model="addForm" :rules="rules" ref="addForm">
        <el-form-item label="设备名称" prop="equipmentName" :label-width="formLabelWidth">
          <el-input v-model="addForm.equipmentName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="终端类型" prop="type" :label-width="formLabelWidth">
          <el-select :disabled="opFlag=='edit'" v-model="addForm.type" placeholder="请选择终端类型">
            <el-option v-for="(val,key) in selectDic('EQUIP_TYPE')" :key="key" :label="val.name" :value="val.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="confirmVisible" @close="confirmCloseHandler" width="30%">
      <span>{{switchObj.msg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmHandler">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog custom-class="calc-his-dialog" title="计价修改记录" :visible.sync="hisDialogVisiable" :lock-scroll="true">
      <div class="calc-his-title">员工类型计费</div>
      <el-table :data="hisTableData1" border style="width: 100%" v-loading="listLoading">
        <el-table-column prop="activeTime" label="生效时间">
          <template slot-scope="scope">
            {{scope.row.beginTime | formateTime}}
          </template>
        </el-table-column>
        <el-table-column prop="reactiveTime" label="失效时间">
          <template slot-scope="scope">
            {{scope.row.endTime | formateTime}}
          </template>
        </el-table-column>
      </el-table>
      <div class="calc-his-title">班次类型计费</div>
      <el-table :data="hisTableData2" border style="width: 100%;" v-loading="listLoading">
        <el-table-column prop="activeTime" label="生效时间">
          <template slot-scope="scope">
            {{scope.row.beginTime | formateTime}}
          </template>
        </el-table-column>
        <el-table-column prop="reactiveTime" label="失效时间">
          <template slot-scope="scope">
            {{scope.row.endTime | formateTime}}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hisDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="hisDialogVisiable=false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import { addEquipment,updateEquipment,getEquipmentList,equCalcSwitch,getEquipmentCalcLogList } from '../../api/equipment'
    import localCache from "../../util/localCache";
export default {
  name: "equipment",
  data() {
    return {
      addDialogVisiable: false,
        opFlag: 'add',
      confirmVisible: false,
      formLabelWidth: '120px',
      tableData: [],
      addForm: {
        equipmentName:'',
        type:''
      },
        rules: {
            equipmentName: [
                { required: true, message: '设备名不能为空', trigger: 'blur' },
                { min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur' }
            ],
            type: [
              { required: true, message: '请选择类型', trigger: 'blur' },
            ],
        },
        listQuery: {
            keyword: ''
        },
        listLoading: true,
        selectRow: '',
      switchObj:{
        type:'',
        status:'',
        msg:'',
        flag: true
      },
      hisDialogVisiable: false,
      hisTableData1: [],
      hisTableData2: [],
    }
  },
    mounted(){
        this.getList()
    },
  methods: {
      addCloseHandler(){
          this.$refs['addForm'].resetFields()
          this.addForm =  {
              equipmentName:'',
            type:''
          }
      },
      addHandler() {
          this.opFlag='add'
          this.addDialogVisiable = true
      },
      editHandler(row) {
          this.selectRow = row
          this.opFlag='edit'
          this.addForm = Object.assign({}, row)
          this.addForm.type += ''
          this.addForm.status += ''
          this.addDialogVisiable = true
      },
      addConfirm() {
          this.$refs['addForm'].validate((valid) => {
              if (!valid) {
                  return
              }
              let param = Object.assign({}, this.addForm)
              if(this.opFlag == 'add'){

              }else if(this.opFlag == 'edit'){
                  param.equipmentId = this.selectRow.equipmentId
              }
              param.customerId = localCache.getCurrentCustomerId()
              if(this.opFlag=='add'){
                  addEquipment(param).then((res)=>{
                      if(res.errorcode==0){
                          this.$message.success('添加成功')
                          this.addDialogVisiable = false
                          this.getList()
                      }else{
                          this.$message.error(res.message)
                      }
                  })
              }else{
                  updateEquipment(param).then((res)=>{
                      if(res.errorcode==0){
                          this.$message.success('修改成功')
                          this.addDialogVisiable = false
                          this.getList()
                      }else{
                          this.$message.error(res.message)
                      }
                  })
              }
          });
      },
      getList() {
          this.listLoading = true
          this.listQuery.customerId = localCache.getCurrentCustomerId()
          getEquipmentList(this.listQuery).then(res => {
              this.listLoading = false
              if (res.errorcode !== 0) {
                  this.$message.error(res.message)
              } else {
                  this.tableData = res.data
              }
          }).catch(() => {
              this.listLoading = false
          })
      },
      // detailHandler(row){
      //     this.$router.push({name:'设备详情',params: {equipmentId: row.equipmentId }})
      // },
    staffTypeCalcChange(newVal){
      this.switchObj.type = 1
      this.switchObj.status = newVal
      if(newVal == 1){
        this.switchObj.msg = '确认开启员工类型计费?'
      }else{
        this.switchObj.msg = '确认关闭员工类型计费?'
      }
      this.confirmVisible = true
      this.switchObj.flag = true
    },
    shiftCalc(newVal){
      this.switchObj.type = 2
      this.switchObj.status = newVal
      if(newVal == 1){
        this.switchObj.msg = '确认开启班次类型计费?'
      }else{
        this.switchObj.msg = '确认关闭班次类型计费?'
      }
      this.confirmVisible = true
      this.switchObj.flag = true
    },
    confirmCloseHandler(){
      if(!this.switchObj.flag){
        return
      }
      if(this.switchObj.type == 2){
        if(this.switchObj.status==1){
          this.selectRow.shiftCalc = 0
        }else{
          this.selectRow.shiftCalc = 1
        }
      }else if(this.switchObj.type == 1){
        if(this.switchObj.status==1){
          this.selectRow.staffTypeCalc = 0
        }else{
          this.selectRow.staffTypeCalc = 1
        }
      }
    },
    confirmHandler(){
      this.switchObj.customerId = localCache.getCurrentCustomerId()
      this.switchObj.subEquipmentId=this.selectRow.subEquipmentId
      equCalcSwitch({
        customerId: localCache.getCurrentCustomerId(),
        equipmentId: this.selectRow.equipmentId,
        status: this.switchObj.status,
        type: this.switchObj.type,
      }).then((res)=>{
        if(res.errorcode==0){
          this.$message.success('修改成功')
          this.switchObj.flag = false
          this.confirmVisible = false
        }else{
          this.$message.error(res.message)
        }
      })
    },
    switchClick(row,column){
      this.selectRow = row
      console.log(row,column)
    },
    switchHis(row){
      console.log(123)
      this.hisDialogVisiable = true
      getEquipmentCalcLogList({
        equipmentId: row.equipmentId,
        customerId: localCache.getCurrentCustomerId()
      }).then(res => {
        this.listLoading = false
        if (res.errorcode !== 0) {
          this.$message.error(res.message)
        } else {
          this.hisTableData1 = res.data.his1
          this.hisTableData2 = res.data.his2
        }
      }).catch(() => {
        this.listLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.t-top-bar{
  margin-bottom: 15px;
}
.search-input {
  width: 350px;
}
.l-add-buttion{
  font-size: 35px;
  float: right;
  cursor: pointer;
}
.calc-his-dialog .el-dialog__body {
  max-height: 550px;
  overflow: auto;
}
.calc-his-title{
  padding: 8px 0;
  font-size: 16px;
}
</style>